import React from "react";
import { makeStyles, createStyles } from "@material-ui/styles";
import { Grid } from "@material-ui/core";

const useStyles: any = makeStyles(() =>
  createStyles({
    root: {
      width: "100%",
      margin: "0 auto",
      marginBottom: 32,
    }
  })
);

export default function FixedContainer({ children }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid container item sm={12} justify="center">
        {children}
      </Grid>
    </div>
  );
}
